import { render, staticRenderFns } from "./AdminWorkspaceTeams.vue?vue&type=template&id=7b435288&scoped=true&"
import script from "./AdminWorkspaceTeams.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspaceTeams.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspaceTeams.vue?vue&type=style&index=0&id=7b435288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b435288",
  null
  
)

export default component.exports